import { RouterLocation } from 'connected-react-router';

import { urlParser } from '@hh.ru/browser-api-utils';

import { LKScrollAnchors, LKSectionState } from 'src/models/pages/lk';
import { CurrentSectionState, ProfessionScrollAnchors } from 'src/models/pages/profession';
import { EdProgramId } from 'src/types/EdProgram';
import { ArticleId, ArticleSlug } from 'src/types/article';
import { CollectionEdProgramDto } from 'src/types/collectionEdProgram/collectionEdProgram';
import { ProfessionId } from 'src/types/profession';
import { SkillId } from 'src/types/skill';
import { StreamId } from 'src/types/stream';

import {
    ADMIN_COURSE_EDIT_ROUTE,
    ADMIN_PROFESSION_EDIT_ROUTE,
    ADMIN_STREAM_EDIT_ROUTE,
    CERT_START_TEST_CODE,
    LK_ROUTE,
    LOGOUT_ROUTE,
    LOGIN_ROUTE,
    PROFESSIONS_ROUTE,
    ADMIN_PROMOTIONS_CATALOG_ROUTE,
    ADMIN_EDUCATION_EDIT_ROUTE,
    ADMIN_ARTICLE_EDIT_ROUTE,
    ARTICLE_ROUTE,
    COLLECTION_ED_PROGRAM_ROUTE,
} from 'src/app/routesUtils/urls';

export const getProfessionRouteHref = (
    id: string,
    {
        section = null,
        grade = null,
        scroll,
    }: { section?: `${CurrentSectionState}` | null; grade?: string | null; scroll?: ProfessionScrollAnchors } = {}
): string => {
    const url = urlParser(`/profession/${id}`);
    url.search = urlParser.stringify({ section, grade, ...(scroll ? { scroll } : {}) });
    return url.href;
};

export const getProfessionsRouteHref = ({
    professionId,
    streamId,
}: { professionId?: ProfessionId; streamId?: StreamId } = {}): string => {
    const url = urlParser(PROFESSIONS_ROUTE);
    url.search = urlParser.stringify({
        professionId: professionId || null,
        streamId: streamId || null,
    });
    return url.href;
};

export const getAdminCourseEditRouteHref = (id: EdProgramId): string => {
    return ADMIN_COURSE_EDIT_ROUTE.replace(':id', id.toString());
};
export const getAdminEducationEditRouteHref = (id: EdProgramId): string => {
    return ADMIN_EDUCATION_EDIT_ROUTE.replace(':id', id.toString());
};

export const getCertStartTestCodeRouteHref = (id: SkillId): string => {
    return `${CERT_START_TEST_CODE}/${id}`;
};

export const getArticleRouteHref = (slug: ArticleSlug): string => {
    return ARTICLE_ROUTE.replace(':slug', slug);
};

export const getCollectionEdProgramRoute = (slug: CollectionEdProgramDto['slug']): string => {
    return COLLECTION_ED_PROGRAM_ROUTE.replace(':slug', slug);
};

export const getCurrentRouteHrefWithParam = (
    routerLocation: RouterLocation<unknown>,
    queryParam: string,
    value: string
): string => {
    const { pathname, search, query } = routerLocation;
    const url = urlParser(`${pathname}${search}`);
    url.search = urlParser.stringify({
        ...query,
        [queryParam]: value,
    });
    return url.href;
};

export const getCurrentRouteHrefWithoutParam = (
    routerLocation: RouterLocation<unknown>,
    queryParam: string
): string => {
    const {
        pathname,
        search,
        query: { [queryParam]: _, ...query },
    } = routerLocation;
    const url = urlParser(`${pathname}${search}`);
    url.search = urlParser.stringify({
        ...query,
    });
    return url.href;
};

export const getAdminStreamEditRouteHref = (id: StreamId): string => {
    return ADMIN_STREAM_EDIT_ROUTE.replace(':id', id.toString());
};

export const getAdminProfessionEditRouteHref = (id: ProfessionId): string => {
    return ADMIN_PROFESSION_EDIT_ROUTE.replace(':id', id.toString());
};

export const getLKRouteHref = (section?: LKSectionState, scroll?: LKScrollAnchors): string => {
    const url = urlParser(LK_ROUTE);
    if (section) {
        url.search = urlParser.stringify({ section, ...(scroll ? { scroll } : {}) });
    }
    return url.href;
};

export const getLogoutRoute = (backurl?: string): string => {
    const url = urlParser(LOGOUT_ROUTE);
    if (backurl) {
        url.search = urlParser.stringify({ backurl });
    }
    return url.href;
};

export const getLoginRoute = (backurl?: string): string => {
    const url = urlParser(LOGIN_ROUTE);
    if (backurl) {
        url.search = urlParser.stringify({ backurl });
    }
    return url.href;
};

export const getAdminPromotionCatalogRoute = (filters: { providerId?: string }): string => {
    const url = urlParser(ADMIN_PROMOTIONS_CATALOG_ROUTE);
    url.search = urlParser.stringify(filters);
    return url.href;
};

export const getAdminArticleEditRoute = (id: ArticleId): string => {
    return ADMIN_ARTICLE_EDIT_ROUTE.replace(':id', id.toString());
};
